export const ELEMENT_CONTROL_CONSTANTS = {
    MOVE: 'move',
    EDIT: 'edit',
    DELETE: 'delete',
    RESIZE: 'resize',
    SENDBACK: 'send-back',
    CLONE: 'clone',
};
